module.exports = __webpack_public_path__ + "static/media/vufindspa.4ba7887a.svg";